import { JobApplicationSource } from '../domain/types/jobApplicationSource';

export const jobApplicationSourceLabels: Record<JobApplicationSource, string> = {
  [JobApplicationSource.INBOUND]: 'Inbound',
  [JobApplicationSource.REFERRAL]: 'Referral',
  [JobApplicationSource.INDEED]: 'Indeed',
  [JobApplicationSource.SUBITO]: 'Subito',
  [JobApplicationSource.WEBINAR]: 'Webinar',
  [JobApplicationSource.SPAM]: 'Spam',
  [JobApplicationSource.SPAM_LINKEDIN]: 'Spam LinkedIn',
  [JobApplicationSource.LINKEDIN]: 'LinkedIn',
  [JobApplicationSource.REFERRAL_AGENZIA]: 'Referral Agenzia',
};
